<template>
  <div id="app">
    <nav class="navbar" v-if="authStore.isAuthenticated">
      <div class="container-fluid">
        <span class="navbar-brand">
          <img :src="logoUrl" alt="11ecom" class="navbar-brand-logo" />
          <span class="navbar-brand-title">Reports</span>
          <span class="navbar-subtitle"></span>
        </span>
        
        <div class="navbar-nav">
          <ul class="nav">
            <li class="nav-item">
              <router-link to="/dashboard" class="nav-link" active-class="active">Dashboard</router-link>
            </li>
            <li class="nav-item"> 
              <router-link to="/shure-monthly" class="nav-link" active-class="active">Shure Monthly Reports</router-link>
            </li>
            <li class="nav-item">
              <router-link to="/stock-take" class="nav-link" active-class="active">Stock-Take</router-link>
            </li>
            <li class="nav-item">
              <router-link to="/snowflake-reports" class="nav-link" active-class="active">Snowflake Reports</router-link>
            </li>
            <li class="nav-item">
              <router-link to="/datev-report" class="nav-link" active-class="active">Billbee DATEV Report</router-link>
            </li>
            <li class="nav-item">
              <router-link to="/products" class="nav-link" active-class="active">Billbee Products</router-link>
            </li>
          </ul>
        </div>

        <div class="navbar-user">
          <span class="navbar-user-name">{{ authStore.displayName }}</span>
          <button class="btn btn-outline btn-sm" type="button" @click="logout">
            Logout
          </button>
        </div>
      </div>        
    </nav>

    <main class="main-content" :class="{ 'main-content-auth': !authStore.isAuthenticated }">
      <router-view />
    </main>

    <footer class="footer" v-if="authStore.isAuthenticated">
      <p>&copy; 2026 11ecom GmbH - ELF Reports v1.0</p>
    </footer>
  </div>
</template>

<script>
import { useAuthStore } from '@/stores/authStore'
import logoUrl from '../assets/img/11ecom-logo.svg'

export default {
  name: 'App',
  data() {
    return {
      logoUrl
    }
  },
  computed: {
    authStore() {
      return useAuthStore()
    }
  },
  methods: {
    async logout() {
      await this.authStore.logout()
      await this.$router.replace({ name: 'Login' })
    }
  }
}
</script>

<style scoped>
/*
.navbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 2rem;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.navbar-brand h1 {
  margin: 0;
  font-size: 1.5rem;
  font-weight: bold;
}

.navbar-subtitle {
  font-size: 0.8rem;
  opacity: 0.8;
  display: block;
}

.navbar-nav {
  display: flex;
  gap: 2rem;
}

.navbar-user {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.navbar-user-name {
  font-size: 0.9rem;
  font-weight: 600;
}

.nav-link {
  color: white;
  text-decoration: none;
  padding: 0.5rem 1rem;
  border-radius: 4px;
  transition: all 0.2s;
}

.nav-link:hover,
.nav-link.active {
  background-color: rgba(255, 255, 255, 0.2);
}
  */
.main-content {
  min-height: calc(100vh - 140px);
  padding: 2rem;
}

.navbar-brand {
  display: inline-flex;
  align-items: center;
  gap: 0.75rem;
  min-width: 0;
}

.navbar-brand-logo {
  display: block;
  width: auto;
  height: 2.25rem;
}

.navbar-brand-title {
  font-size: 1.25rem;
  font-weight: 700;
  line-height: 1;
  white-space: nowrap;
}


.main-content-auth {
  min-height: 100vh;
  padding: 0;
}

.footer {
  text-align: center;
  padding: 1rem;
  background-color: #f8f9fa;
  border-top: 1px solid #dee2e6;
  color: #6c757d;
}
</style>
